var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowseFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75005 0C1.67895 0 0 1.6789 0 3.74993V16.2501C0 18.3211 1.67895 20 3.75005 20H21.2499C23.3213 20 25 18.3211 25 16.2501V6.25007C25 4.17903 23.3213 2.50013 21.2499 2.50013H13.4504C13.1442 2.50013 12.8488 2.38776 12.6198 2.18436L11.2281 0.947421C10.5418 0.337199 9.65532 8.05159e-05 8.73682 8.05159e-05L3.75005 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseFiles);
export default __webpack_public_path__ + "static/media/BrowseFiles.2570a880c2cc027905fb5f209f9bc010.svg";
export { ForwardRef as ReactComponent };